import { getTelemetry } from '../telemetry/api';
import type { LeaderboardApi } from '../telemetry/leaderboard';

/**
 * Accès des écrans au client des classements : `api.leaderboard` (A87, lot A),
 * lu dynamiquement. Jamais d'exception (A79) ; `null` tant que la télémétrie
 * n'est pas installée (les écrans affichent alors « indisponible »).
 */
export function getLeaderboard(): LeaderboardApi | null {
  try {
    return getTelemetry()?.leaderboard ?? null;
  } catch {
    return null;
  }
}
